/**
 * Helper class.
 * @type {{urlExists: ((function(String): Boolean)|*), registerJs: Helper.registerJs, registerCss: Helper.registerCss, youtubeId: ((function(String): String)|*)}}
 */
export const Helper = (function() {
	// declare public variables and/or functions
	return {
		/**
		 * Register CSS files.
		 * @param {Array} [files] array of files to be added
		 * @param {String} [element] element where to add files
		 */
		registerCss: function(files, element) {
			// validate argument
			if ('undefined' === typeof files || (!('undefined' === typeof files) && !Array.isArray(files))) {return;}
			if ('undefined' === typeof element) {element = 'head';}

			// register CSS files
			let link;
			const elementDOM = document.getElementsByTagName(element)[0];
			if (files.length) {
				for (let i = 0; i < files.length; i++) {
					// create 'LINK' element
					link = document.createElement('link');
					link.type = 'text/css';
					link.rel = 'stylesheet';
					link.href = files[i];

					// add it to 'HEAD' section
					elementDOM.appendChild(link);
				}
			}
		},



		/**
		 * Register JS files.
		 * @param {Array} [files] array of files to be added
		 * @param {String} [element] element where to add files
		 */
		registerJs: function(files, element) {
			// validate argument
			if ('undefined' === typeof files || (!('undefined' === typeof files) && !Array.isArray(files))) {return;}
			if ('undefined' === typeof element) {element = 'head';}

			// register CSS files
			let script;
			const elementDOM = document.getElementsByTagName(element)[0];
			if (files.length) {
				for (let i = 0; i < files.length; i++) {
					// create 'LINK' element
					script = document.createElement('script');
					script.type = 'text/javascript';
					script.src = files[i];

					// add it to 'HEAD' section
					elementDOM.appendChild(script);
				}
			}
		},



		/**
		 * Get youtube video id from url.
		 * @param {String} url url
		 * @return {String} video id
		 */
		youtubeId: function(url) {
			// validate argument
			if ('undefined' === typeof url || null === url) {return null;}

			// get id
			const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
			const match = url.match(regExp);
			return (match && match[7].length === 11) ? match[7] : null;
		},



		/**
		 * Detect if url exists (i.e. no 404 error).
		 * @param {String} url url
		 * @return {Boolean} if url exists
		 */
		urlExists: function(url) {
			// validate argument
			if ('undefined' === typeof url || null === url) {return false;}

			// check if image exists
			let img = new Image();
			img.src = url;
			console.log($(img).width());
			return img.height !== 0;
		}
	}
})();


/**
 * Init the site.
 * @type {{aosRefresh: Init.aosRefresh, backToTop: Init.backToTop, alertBoxes: Init.alertBoxes, photoswipeVideos: Init.photoswipeVideos, photoswipeGallery: Init.photoswipeGallery, aosInit: Init.aosInit, addUserAgent: Init.addUserAgent, masonry: Init.masonry, menuOnScrolldown: Init.menuOnScrolldown, advicesBackground: Init.advicesBackground, advicesParticles: Init.advicesParticles, preloader: Init.preloader, smoothScroll: Init.smoothScroll, offCanvas: Init.offCanvas, clickSlider: Init.clickSlider}}
 */
export const Init = (function() {
	// declare private variables and/or functions
	const _$win = $(window);

	// declare public variables and/or functions
	return {
		/**
		 * Add the User Agent to the <html> (will be used for IE10 detection)
		 */
		addUserAgent: function() {
			const doc = document.documentElement;
			doc.setAttribute('data-useragent', navigator.userAgent);
		},



		/**
		 * Init preloader.
		 */
		preloader: function() {
			// on load event
			_$win.on('load', function() {
				// force page scroll position to top at page refresh
				// $('html, body').animate({ scrollTop: 0 }, 'normal');

				// will first fade out the loading animation
				$('#loader').fadeOut('slow', function () {
					// will fade out the whole DIV that covers the website.
					$('#preloader').delay(300).fadeOut('slow');
				});

				// for hero content animations
				const $html = $("html");
				$html.removeClass('cl-preload');
				$html.addClass('cl-loaded');
			});
		},



		/**
		 * Menu on Scrolldown.
		 */
		menuOnScrolldown: function() {
			// menu element
			const $menuTrigger = $('.header-menu-toggle');
			const $languagepickerTrigger = $('.header-languagepicker');

			// on scroll event
			_$win.on('scroll', function () {
				if (_$win.scrollTop() > 150) {
					$menuTrigger.addClass('opaque');
					$languagepickerTrigger.addClass('opaque');
				} else {
					$menuTrigger.removeClass('opaque');
					$languagepickerTrigger.removeClass('opaque');
				}
			});
		},



		/**
		 * OffCanvas Menu.
		 */
		offCanvas: function() {
			// get elements
			const $menuTrigger = $('.header-menu-toggle');
			const $nav = $('.header-nav');
			const $closeButton = $nav.find('.header-nav__close');
			const $siteBody = $('body');
			// const $mainContents = $('section, footer');

			// open-close menu by clicking on the menu icon
			$menuTrigger.on('click', function (e) {
				e.preventDefault();
				// $menuTrigger.toggleClass('is-clicked');
				$siteBody.toggleClass('menu-is-open');
			});

			// close menu by clicking the close button
			$closeButton.on('click', function (e) {
				e.preventDefault();
				$menuTrigger.trigger('click');
			});

			// close menu clicking outside the menu itself
			$siteBody.on('click', function (e) {
				if (!$(e.target).is('.header-nav, .header-nav__content, .header-menu-toggle, .header-menu-toggle span')) {
					// $menuTrigger.removeClass('is-clicked');
					$siteBody.removeClass('menu-is-open');
				}
			});
		},



		/**
		 * Init photoswipe for gallery.
		 */
		photoswipeGallery: function() {
			// get elements
			let items = [];
			const $pswp = $('.pswp')[0];
			const $folioItems = $('.s-works').find('.item-folio');

			// get items
			let $folio, $thumbLink, $title, $caption, titleText, captionText, href, size, width, height, item;
			$folioItems.each(function () {
				// generate item
				$folio = $(this);
				$thumbLink = $folio.find('.thumb-link');
				$title = $folio.find('.item-folio__title');
				$caption = $folio.find('.item-folio__caption');
				titleText = '<h4>' + $.trim($title.html()) + '</h4>';
				captionText = $.trim($caption.html());
				href = $thumbLink.attr('href');
				size = $thumbLink.data('size').split('x');
				width  = size[0];
				height = size[1];

				item = {
					src: href,
					w: width,
					h: height
				};

				if ($caption.length > 0) {
					item.title = $.trim(titleText + captionText);
				}

				// add item
				items.push(item);
			});

			// bind click event
			let options, lightBox;
			$folioItems.each(function (i) {
				$(this).on('click', function (e) {
					e.preventDefault();
					options = {
						index: i,
						showHideOpacity: true
					};

					// initialize PhotoSwipe
					lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
					lightBox.init();
				});
			});
		},



		/**
		 * Init photoswipe for videos.
		 */
		photoswipeVideos: function() {
			/**
			 * Parse slide data (url, title, size etc) from DOM elements (children of gallerySelector)
			 * @param {String} el element
			 * @returns {Array}
			 */
			const parseThumbnailElements = function(el) {
				// define vars
				const thumbElements = $(el).find('.photoswipe-item:not(.isotope-hidden)').get();
				const numNodes = thumbElements.length;
				let items = [];
				let figureEl, $figureEl, linkEl, $linkEl, item;

				// loop through number of nodes
				for (let i = 0; i < numNodes; i++) {
					// <figure> element
					figureEl = thumbElements[i];
					$figureEl = $(figureEl);

					// include only element nodes
					if (figureEl.nodeType !== 1) {continue;}

					// <a> element
					linkEl = figureEl.children[0];
					$linkEl = $(linkEl);
					if ('video' !== $linkEl.data('type')) {continue;}

					// create slide object
					item = {
						html: $linkEl.data('video')
					};

					if (figureEl.children.length > 1) {
						// <figcaption> content
						item.title = $figureEl.find('.caption').html();
					}

					if (linkEl.children.length > 0) {
						// <img> thumbnail element, retrieving thumbnail url
						item.msrc = linkEl.children[0].getAttribute('src');
					}

					// save link to element for getThumbBoundsFn
					item.el = figureEl;
					items.push(item);
				}

				// result
				return items;
			};



			/**
			 * Find nearest parent element.
			 * @param {Object} el element
			 * @param {function} fn callback function
			 * @returns {Object}
			 */
			const closest = function closest(el, fn) {
				return el && (fn(el) ? el : closest(el.parentNode, fn));
			};



			/**
			 * Detect if element has class.
			 * @param {Object} element element
			 * @param {String} cls class name
			 * @returns {Boolean} whether element has class
			 */
			const hasClass = function(element, cls) {
				return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
			};



			/**
			 * Triggers when user clicks on thumbnail.
			 * @param {Object} e event object
			 * @returns {*}
			 */
			const onThumbnailsClick = function(e) {
				// get event
				e = e || window.event;
				e.preventDefault ? e.preventDefault() : e.returnValue = false;

				// get event target
				const eTarget = e.target || e.srcElement;

				// find root element of slide
				const clickedListItem = closest(eTarget,
					/**
					 * Detect if element has class.
					 * @callback requestCallback
					 * @param el
					 * @returns {Boolean}
					 */
					function(el) {
						return (hasClass(el, 'photoswipe-item'));
					}
				);

				if (!clickedListItem) {
					return;
				}

				// find index of clicked item by looping through all child nodes; alternatively, you may define index via data- attribute
				const clickedGallery = clickedListItem.closest('.photoswipe-wrapper');
				const childNodes = $(clickedListItem.closest('.photoswipe-wrapper')).find('.photoswipe-item:not(.isotope-hidden)').get();
				const numChildNodes = childNodes.length;
				let nodeIndex = 0, index;

				for (let i = 0; i < numChildNodes; i++) {
					if (childNodes[i].nodeType !== 1) {
						continue;
					}

					if (childNodes[i] === clickedListItem) {
						index = nodeIndex;
						break;
					}

					nodeIndex++;
				}

				if (index >= 0) {
					// open PhotoSwipe if valid index found
					openPhotoSwipe(index, clickedGallery);
				}

				return false;
			};



			/**
			 * Parse picture index and gallery index from URL (#&pid=1&gid=2).
			 */
			const photoswipeParseHash = function() {
				// get params
				const hash = window.location.hash.substring(1);
				let params = {};

				if (hash.length < 5) {
					return params;
				}

				const vars = hash.split('&');
				for (let i = 0; i < vars.length; i++) {
					if (!vars[i]) {continue;}

					const pair = vars[i].split('=');
					if (pair.length < 2) {continue;}

					params[pair[0]] = pair[1];
				}

				if (params.gid) {
					params.gid = parseInt(params.gid, 10);
				}

				return params;
			};



			/**
			 * Open photoswipe modal window.
			 * @param index
			 * @param galleryElement
			 * @param disableAnimation
			 * @param fromURL
			 */
			const openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
				const pswpElement = document.querySelectorAll('.pswp')[0];
				let gallery, options, items;

				items = parseThumbnailElements(galleryElement);

				// define options (if needed)
				options = {
					closeOnScroll: false,
					galleryUID: galleryElement.getAttribute('data-pswp-uid'), // define gallery index (for URL)
					getThumbBoundsFn: function (index) {
						// See Options -> getThumbBoundsFn section of documentation for more info
						const thumbnail = items[index].el.getElementsByTagName('img')[0]; // find thumbnail
						const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
						const rect = thumbnail.getBoundingClientRect();

						return {
							x: rect.left,
							y: rect.top + pageYScroll,
							w: rect.width
						};
					}
				};

				// PhotoSwipe opened from URL
				if (fromURL) {
					if (options.galleryPIDs) {
						// parse real index when custom PIDs are used
						// http://photoswipe.com/documentation/faq.html#custom-pid-in-url
						for (let j = 0; j < items.length; j++) {
							if (items[j].pid === index) {
								options.index = j;
								break;
							}
						}
					} else {
						// in URL indexes start from 1
						options.index = parseInt(index, 10) - 1;
					}
				} else {
					options.index = parseInt(index, 10);
				}

				// exit if index not found
				if (isNaN(options.index)) {
					return;
				}

				if (disableAnimation) {
					options.showAnimationDuration = 0;
				}

				// Pass data to PhotoSwipe and initialize it
				gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
				gallery.init();

				gallery.listen('beforeChange', function () {
					const $video = $('.pswp__video');
					const currItem = $(gallery.currItem.container);
					$video.removeClass('active');
					currItem.find('.pswp__video').addClass('active');
					$video.each(function( ) {
						if (!$(this).hasClass('active')) {
							$(this).attr('src', $(this).attr('src'));
						}
					});
				});

				gallery.listen('close', function() {
					$('.pswp__video').each(function() {
						$(this).attr('src', $(this).attr('src'));
					});
				});

			};

			// loop through all gallery elements and bind events
			const galleryElements = document.querySelectorAll('.photoswipe-wrapper');

			for (let i = 0, l = galleryElements.length; i < l; i++) {
				galleryElements[i].setAttribute('data-pswp-uid', i + 1);
				galleryElements[i].onclick = onThumbnailsClick;
			}

			// parse URL and open gallery if it contains #&pid=3&gid=1
			const hashData = photoswipeParseHash();
			if (hashData.pid && hashData.gid) {
				openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
			}
		},



		/**
		 * Init masonry.
		 * @param {jQuery} [$masonry] masonry items
		 * @param {Boolean} [loadedEvent] whether to add event listener
		 */
		masonry: function($masonry, loadedEvent = true) {
			// validate arguments
			if ('undefined' === typeof $masonry || null === $masonry || !($masonry instanceof jQuery)) {
				$masonry = $('.masonry');
			}

			// init masonry
			if (loadedEvent) {
				$masonry.imagesLoaded(function () {
					$masonry.masonry({
						itemSelector: '.masonry__brick',
						resize: true
					});
				});
			} else {
				$masonry.masonry({
					itemSelector: '.masonry__brick',
					resize: true
				});
			}
		},



		/**
		 * Click slider.
		 */
		clickSlider: function() {
			$('.testimonials').slick({
				arrows: true,
				dots: false,
				infinite: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				adaptiveHeight: true,
				pauseOnFocus: false,
				autoplaySpeed: 1500,
				responsive: [
					{
						breakpoint: 900,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 800,
						settings: {
							arrows: false,
							dots: true
						}
					}
				]
			});
		},



		/**
		 * Smooth scroll.
		 */
		smoothScroll: function() {
			// on click event
			let target, $target;
			$('.smoothscroll').on('click', function (e) {
				// get element
				target = this.hash;
				$target = $(target);

				// prevent default behaviour
				e.preventDefault();
				e.stopPropagation();

				// run animation
				$('html, body').stop().animate({
					'scrollTop': $target.offset().top
				}, 800, 'swing').promise().done(function () {
					// check if menu is open
					if ($('body').hasClass('menu-is-open')) {
						$('.header-menu-toggle').trigger('click');
					}

					window.location.hash = target;
				});
			});
		},



		/**
		 * Alert boxes.
		 */
		alertBoxes: function() {
			$('.alert-box').on('click', '.alert-box__close', function () {
				$(this).parent().fadeOut(500);
			});
		},



		/**
		 * Animate on scroll.
		 */
		aosInit: function() {
			AOS.init( {
				offset: 200,
				duration: 600,
				easing: 'ease-in-sine',
				delay: 300,
				once: true,
				// disable: window.innerWidth < 1024,
				disable: 'mobile',
				startEvent: 'load'
			});
		},



		/**
		 * Refresh AOS.
		 * @param {Boolean} [hard] whether to make a hard refresh
		 */
		aosRefresh: function(hard = false) {
			if (hard) {
				AOS.refreshHard();
			} else {
				AOS.refresh();
			}
		},



		/**
		 * Back to top.
		 */
		backToTop: function() {
			// define settings
			const pxShow  = 500; // height on which the button will show
			const fadeInTime  = 400; // how slow/fast you want the button to show
			const fadeOutTime = 400; // how slow/fast you want the button to hide
			// const scrollSpeed = 300; // how slow/fast you want the button to scroll to top. can be a value, 'slow', 'normal' or 'fast'
			const $goTopButton = $('.go-top');

			// Show or hide the sticky footer button
			$(window).on('scroll', function() {
				if ($(window).scrollTop() >= pxShow) {
					$goTopButton.fadeIn(fadeInTime);
				} else {
					$goTopButton.fadeOut(fadeOutTime);
				}
			});
		},



		/**
		 * Init animated background for 'Advices' section.
		 * @param {number} ballsNum number of balls
		 */
		advicesBackground: function(ballsNum = 50) {
			// redefine balls number
			if ('undefined' === typeof ballsNum || null === ballsNum) {
				ballsNum = 50;
			}

			// array of possible ball colors
			const colors = ['#3CC157', '#2AA7FF', '#1B1B1B', '#FCBC0F', '#F85F36'];

			// init balls array
			const balls = [];

			// advices block
			const $advices = document.getElementById('advices');

			// loop through balls
			let ball;
			for (let i = 0; i < ballsNum; i++) {
				// create DIV element
				ball = document.createElement('div');

				// add CSS class
				ball.classList.add('ball');

				// pick random color
				ball.style.background = colors[Math.floor(Math.random() * colors.length)];

				// set position
				ball.style.left = `${Math.floor(Math.random() * 100)}vw`;
				ball.style.top = `${Math.floor(Math.random() * 100)}vh`;

				// set size
				ball.style.transform = `scale(${Math.random()})`;
				ball.style.width = `${Math.random()}em`;
				ball.style.height = ball.style.width;

				// add element
				balls.push(ball);
				$advices.append(ball);
			}

			// keyframes
			let to, anim;
			balls.forEach((el, i, ra) => {
				// next ball position
				to = {
					x: Math.random() * (i % 2 === 0 ? -11 : 11),
					y: Math.random() * 12
				};

				// animation
				anim = el.animate(
					[
						{ transform: "translate(0, 0)" },
						{ transform: `translate(${to.x}rem, ${to.y}rem)` }
					],
					{
						duration: (Math.random() + 1) * 2000, // random duration
						direction: "alternate",
						fill: "both",
						iterations: Infinity,
						easing: "ease-in-out"
					}
				);
			});
		},



		/**
		 * Init particles animation.
		 */
		advicesParticles: function() {
			// config
			const config = {
				"particles": {
					"number": {
						"value": 60,
						"density": {
							"enable": true,
							"value_area": 500
						}
					},
					"color": {
						"value": "#525252"
					},
					"shape": {
						"type": "circle",
						"stroke": {
							"width": 0,
							"color": "#000000"
						},
						"polygon": {
							"nb_sides": 5
						},
						"image": {
							"src": "img/github.svg",
							"width": 100,
							"height": 100
						}
					},
					"opacity": {
						"value": 0.5,
						"random": false,
						"anim": {
							"enable": false,
							"speed": 1,
							"opacity_min": 0.1,
							"sync": false
						}
					},
					"size": {
						"value": 3,
						"random": true,
						"anim": {
							"enable": false,
							"speed": 40,
							"size_min": 0.1,
							"sync": false
						}
					},
					"line_linked": {
						"enable": true,
						"distance": 150,
						"color": "#d1d1d1",
						"opacity": 0.4,
						"width": 1
					},
					"move": {
						"enable": true,
						"speed": 2,
						"direction": "none",
						"random": false,
						"straight": false,
						"out_mode": "out",
						"bounce": false,
						"attract": {
							"enable": false,
							"rotateX": 600,
							"rotateY": 1200
						}
					}
				},
				"interactivity": {
					"detect_on": "canvas",
					"events": {
						"onhover": {
							"enable": false,
							"mode": "repulse"
						},
						"onclick": {
							"enable": false,
							"mode": "push"
						},
						"resize": true
					},
					"modes": {
						"grab": {
							"distance": 400,
							"line_linked": {
								"opacity": 1
							}
						},
						"bubble": {
							"distance": 400,
							"size": 40,
							"duration": 2,
							"opacity": 8,
							"speed": 3
						},
						"repulse": {
							"distance": 200,
							"duration": 0.4
						},
						"push": {
							"particles_nb": 4
						},
						"remove": {
							"particles_nb": 2
						}
					}
				},
				"retina_detect": true
			};

			// init
			particlesJS('advices', config);
		}
	}
})();



// WEBPACK FOOTER //
// ./src/assets/js/common.classes.js